export const services = [
  {
    slug: "bokforing",
    title: "Löpande bokföring",
    short: "Digital bokföring som sparar tid — och frigör tid för rådgivning.",
    icon: "FileSpreadsheet",
  },
  {
    slug: "bokslut",
    title: "Bokslut & deklaration",
    short: "Proaktivt bokslutsarbete med tydliga checklistor och inga överraskningar.",
    icon: "ClipboardCheck",
  },
  {
    slug: "radgivning",
    title: "Rådgivning & tillväxt",
    short: "Strategisk vägledning för att ditt företag ska nå sin fulla potential.",
    icon: "TrendingUp",
  },
  {
    slug: "inhouse",
    title: "Inhouse-medarbetare",
    short: "En tillfällig förstärkning till din ekonomiavdelning, på plats hos dig.",
    icon: "Users",
  },
  {
    slug: "loneadministration",
    title: "Löneadministration",
    short: "Löner som alltid blir rätt — så att du kan fokusera på företagets tillväxt.",
    icon: "Wallet",
  },
] as const;

export const cases = [
  {
    slug: "larsson-bygg",
    title: "Larsson Bygg stärker sin ekonomiska kompetens",
    excerpt:
      "Ett samarbete där Cloud och H & B Larsson Bygg delar på ekonomiarbetet — samtidigt som bolaget stegvis bygger upp intern kompetens.",
    image: "case-2",
  },
  {
    slug: "paus",
    title: "Digital omställning gav Paus bättre kontroll",
    excerpt:
      "Caféet Paus i Vännäs valde att satsa på en digital omställning med Cloud — och fick bättre kontroll över ekonomin på köpet.",
    image: "case-3",
  },
  {
    slug: "sodra-bygg",
    title: "Cloud blir nyckelpartner när Södra Bygg växlar upp",
    excerpt:
      "Genom flexibelt upplägg, digitalt arbetssätt och strategisk rådgivning har Cloud blivit en nyckelpartner i Södra Byggs tillväxt.",
    image: "case-1",
  },
  {
    slug: "pt-online",
    title: "PT Online effektiviserar verksamheten",
    excerpt:
      "Genom att lämna över ekonomin kan Alexander Elebro lägga sin tid där den gör mest nytta — på företagets tillväxt.",
    image: "case-4",
  },
] as const;

export const news = [
  {
    slug: "trygg-hjalp",
    title: "Trygg hjälp när ekonomin krånglar",
    excerpt:
      "När företagets ekonomi känns svår finns Cloud som ett stöd på vägen tillbaka — ofta snabbare än väntat.",
    date: "2026-03-12",
    category: "Insikt",
  },
  {
    slug: "arets-tillvaxtbyra",
    title: "Årets tillväxtbyrå — andra året i rad",
    excerpt:
      "För andra året i rad utses Cloud Redovisning till Årets tillväxtbyrå i Västerbottens län.",
    date: "2026-02-04",
    category: "Utmärkelse",
  },
  {
    slug: "elin-lonechef",
    title: "Elin blir ny chef för löneavdelningen",
    excerpt:
      "Lönespecialisten Elin Morin tillträder som lönechef och menar att rätt processer både sparar tid och pengar.",
    date: "2026-01-22",
    category: "Team",
  },
  {
    slug: "ny-ai-kompetens",
    title: "Ny AI-kompetens till Cloud Redovisning",
    excerpt:
      "Vår nyaste medarbetare Johan Rutberg kombinerar lång branscherfarenhet med djup AI-kompetens.",
    date: "2025-12-15",
    category: "Team",
  },
  {
    slug: "lonebackup",
    title: "Lönebackup — trygghet vid akut frånvaro",
    excerpt:
      "En backup-funktion som ger dig en pålitlig lösning när er ordinarie löneadministratör är borta.",
    date: "2025-11-08",
    category: "Tjänst",
  },
  {
    slug: "fyra-steg",
    title: "Fyra steg för affärsutveckling",
    excerpt:
      "Så här erbjuder vi i fyra konkreta steg ökad trygghet och bättre resultat för ditt företag.",
    date: "2025-10-30",
    category: "Insikt",
  },
] as const;

export const team = [
  {
    name: "Lisa Vilminko",
    role: "Kontorschef Umeå · Auktoriserad redovisningskonsult",
    image: "team-lisa",
    email: "lisa.vilminko@cloudredovisning.se",
    phone: "070-663 60 40",
    office: "Umeå",
  },
  {
    name: "Linus Sjögren",
    role: "Kontorschef Stockholm · Redovisningskonsult",
    image: "team-linus",
    email: "linus.sjogren@cloudredovisning.se",
    phone: "070-012 12 11",
    office: "Stockholm",
  },
  {
    name: "Elin Morin",
    role: "Lönechef · Lönespecialist",
    image: "team-elin",
    email: "elin.morin@cloudredovisning.se",
    phone: "070-303 63 47",
    office: "Umeå",
  },
  {
    name: "Johan Rutberg",
    role: "Redovisningskonsult · AI-specialist",
    image: "team-johan",
    email: "johan.rutberg@cloudredovisning.se",
    phone: "070-303 63 49",
    office: "Stockholm",
  },
] as const;

export const employees = [
  {
    name: "Lisa Vilminko",
    role: "Kontorschef Umeå · Auktoriserad redovisningskonsult",
    image: "team-lisa",
    email: "lisa.vilminko@cloudredovisning.se",
    phone: "070-663 60 40",
    office: "Umeå",
  },
  {
    name: "Linus Sjögren",
    role: "Kontorschef Stockholm · Redovisningskonsult",
    image: "team-linus",
    email: "linus.sjogren@cloudredovisning.se",
    phone: "070-012 12 11",
    office: "Stockholm",
  },
  {
    name: "Samuel Önnbo",
    role: "VD · Auktoriserad redovisningskonsult",
    email: "samuel@cloudredovisning.se",
    phone: "070-303 63 45",
  },
  {
    name: "Per Lindström",
    role: "Ägare",
    email: "per@cloudredovisning.se",
    phone: "070-281 81 85",
  },
  {
    name: "Anna-Karin Nylund",
    role: "Gruppchef · Redovisningskonsult",
    email: "anna-karin.nylund@cloudredovisning.se",
    phone: "070-558 70 48",
  },
  {
    name: "Elin Morin",
    role: "Lönechef",
    image: "team-elin",
    email: "elin.morin@cloudredovisning.se",
    phone: "076-780 54 06",
  },
  {
    name: "Lovisa Ersson",
    role: "Gruppchef · Redovisningskonsult",
    email: "lovisa.ersson@cloudredovisning.se",
    phone: "070-355 89 92",
  },
  {
    name: "Veronica Östhagen",
    role: "Redovisningskonsult",
    email: "veronica@cloudredovisning.se",
    phone: "073-085 41 33",
  },
  {
    name: "Angelica Vesterlund",
    role: "Redovisningskonsult",
    email: "angelica.vesterlund@cloudredovisning.se",
    phone: "070-352 57 67",
  },
  {
    name: "Julia Prowse",
    role: "Redovisningskonsult",
    email: "julia.prowse@cloudredovisning.se",
  },
  {
    name: "Sandra Fransson",
    role: "Redovisningskonsult",
    email: "sandra.fransson@cloudredovisning.se",
    phone: "070-667 36 05",
  },
  {
    name: "Sebastian Bauer",
    role: "Redovisningskonsult",
    email: "sebastian.bauer@cloudredovisning.se",
    phone: "070-256 35 24",
  },
  {
    name: "Tomas Strandberg",
    role: "Redovisningskonsult",
    email: "tomas.strandberg@cloudredovisning.se",
    phone: "073-405 36 86",
  },
  {
    name: "Angelica Nordmark",
    role: "Lönekonsult",
    email: "angelica.nordmark@cloudredovisning.se",
    phone: "076-108 65 53",
  },
  {
    name: "Hanna Marklund",
    role: "Auktoriserad redovisningskonsult",
    email: "hanna.marklund@cloudredovisning.se",
    phone: "076-800 10 55",
  },
  {
    name: "Jessica Smeij",
    role: "Redovisningskonsult",
    email: "jessica.smeij@cloudredovisning.se",
    phone: "073-800 64 96",
  },
  {
    name: "Patricia Zingmark",
    role: "Redovisningskonsult",
    email: "patricia.zingmark@cloudredovisning.se",
    phone: "070-334 19 60",
  },
  {
    name: "Johan Rutberg",
    role: "Redovisningskonsult",
    image: "team-johan",
    email: "johan.rutberg@cloudredovisning.se",
    phone: "070-850 72 95",
    office: "Stockholm",
  },
  {
    name: "Simon Larsson",
    role: "Redovisningskonsult",
    email: "simon.larsson@cloudredovisning.se",
    phone: "070-208 10 37",
  },
  {
    name: "Lena Johansson",
    role: "Redovisningskonsult",
    email: "lena.johansson@cloudredovisning.se",
    phone: "073-065 77 06",
  },
  {
    name: "Liubov Koss",
    role: "Redovisningskonsult",
    email: "liubov.koss@cloudredovisning.se",
    phone: "076-282 94 00",
  },
  {
    name: "Johan Norström",
    role: "Redovisningskonsult",
    email: "johan.norstrom@cloudredovisning.se",
    phone: "073-802 84 07",
  },
  {
    name: "Cecilia Gustafsson",
    role: "Redovisningskonsult",
    email: "cecilia.gustafsson@cloudredovisning.se",
    phone: "070-650 60 52",
  },
  {
    name: "Alva Ohlsson",
    role: "Löneassistent",
    email: "alva.ohlsson@cloudredovisning.se",
  },
  {
    name: "Nina Hjortsmark",
    role: "Redovisningskonsult",
    email: "nina.hjortsmark@cloudredovisning.se",
    phone: "072-203 85 32",
  },
  {
    name: "Maria Isabel Söderström",
    role: "Redovisningskonsult",
  },
] as const;
